<script setup>
import { RouterLink } from 'vue-router'
import { ROUTES } from '../../core/config/constants.js'
</script>

<template>
  <div class="document-page">
    <!-- Header -->
    <header class="document-header">
      <div class="header-content">
        <RouterLink :to="{ name: ROUTES.HOME }" class="back-link">
          <svg
            viewBox="0 0 24 24"
            width="20"
            height="20"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M5 12H19M12 5l7 7-7 7" />
          </svg>
          <span>חזרה</span>
        </RouterLink>
        <RouterLink :to="{ name: ROUTES.HOME }" class="logo-wrapper">
          <img src="@/assets/logo/logo_76.png" alt="GoFood" class="logo-img" />
          <span class="logo-text">GoFood</span>
        </RouterLink>
      </div>
    </header>

    <!-- Content -->
    <main class="document-main">
      <article class="document-content">
        <h1>הצהרת נגישות – מערכת סחר B2B (GoFood)</h1>

        <p>
          רוסמן לוגיסטיקה בע״מ ("החברה") רואה חשיבות רבה בהנגשת שירותיה לאנשים עם מוגבלות ופועלת
          לקידום נגישות, שוויון ועצמאות גם בערוצים הדיגיטליים. החברה פועלת לביצוע התאמות נגישות
          בהתאם להוראות חוק שוויון זכויות לאנשים עם מוגבלות, התשנ״ח-1998, ולתקנות הרלוונטיות, ובכלל
          זה בהתאם לתקן הישראלי ת״י 5568 לנגישות תכני אינטרנט.
        </p>

        <h2>1. תחולת ההצהרה</h2>
        <p>
          הצהרה זו מתייחסת לנגישות <strong>המערכת הדיגיטלית</strong> של החברה (אתר/אפליקציה/ממשקי
          הזמנה), המיועדת לשימוש עסקי (B2B).
        </p>

        <h2>2. רמת נגישות ותקן</h2>
        <p>
          המערכת הונגשה בהתאם לתקן הישראלי <strong>ת״י 5568</strong> ברמת
          <strong>AA</strong> (בהתבסס על עקרונות WCAG 2.0), במטרה לאפשר שימוש נוח ונגיש לכלל
          המשתמשים, לרבות משתמשים הנעזרים בטכנולוגיות מסייעות.
        </p>

        <h2>3. התאמות נגישות שבוצעו במערכת</h2>
        <p>הנגישות במערכת באה לידי ביטוי, בין היתר, בנושאים הבאים:</p>
        <ul>
          <li>התאמה לגלישה ממחשב נייח, מחשב נייד ומכשירים סלולריים (Responsive).</li>
          <li>
            אפשרות ניווט באמצעות מקלדת:
            <ul>
              <li>מעבר בין רכיבים באמצעות מקש <strong>Tab</strong>.</li>
              <li>הפעלה באמצעות מקש <strong>Enter</strong>.</li>
            </ul>
          </li>
          <li>מבנה עמודים סמנטי ותקני (כותרות, אזורים, טפסים, קישורים ורכיבים).</li>
          <li>תיוג טקסטואלי לרכיבים שאינם טקסטואליים (לרבות תמונות ורכיבי ממשק רלוונטיים).</li>
          <li>
            תמיכה בטכנולוגיות מסייעות, לרבות קוראי מסך. לשימוש מיטבי מומלץ להיעזר בקוראי מסך כגון
            <strong>NVDA</strong> (Windows) או <strong>VoiceOver</strong> (macOS/iOS).
          </li>
          <li>פוקוס מקלדת נראה לעין (Keyboard Focus) לשיפור התמצאות בעת ניווט ללא עכבר.</li>
        </ul>

        <h2>4. הגדלת והקטנת תצוגה (Zoom)</h2>
        <p>ניתן להגדיל את התצוגה באמצעות לחיצה בו-זמנית על:</p>
        <ul>
          <li><strong>Ctrl +</strong> (קונטרול ופלוס)</li>
        </ul>
        <p>ולהקטין באמצעות:</p>
        <ul>
          <li><strong>Ctrl -</strong> (קונטרול ומינוס)</li>
        </ul>
        <p>בנוסף, ניתן להשתמש בהגדלת התצוגה המובנית בדפדפן.</p>

        <h2>5. סייגים וחריגים</h2>
        <p>
          על אף מאמצי החברה להנגיש את כלל רכיבי המערכת, ייתכן שיתגלו חלקים שטרם הונגשו באופן מלא, או
          שיידרשו התאמות נקודתיות (למשל בעקבות עדכוני מערכת/תוכן/צדדים שלישיים). החברה ממשיכה לפעול
          לשיפור מתמיד של הנגישות.
        </p>

        <h2>6. יצירת קשר בנושא נגישות</h2>
        <p>
          אם נתקלת בקושי או בתקלה בנושא נגישות, נשמח לקבל פנייה ולטפל בה בהקדם. כדי שנוכל לסייע
          ביעילות, מומלץ לציין בפנייה:
        </p>
        <ul>
          <li>תיאור הבעיה</li>
          <li>כתובת העמוד/המסך שבו התרחשה</li>
          <li>סוג הדפדפן/המכשיר</li>
          <li>טכנולוגיה מסייעת שבה נעשה שימוש (אם רלוונטי)</li>
        </ul>

        <div class="contact-box">
          <h3>פרטי קשר:</h3>
          <ul>
            <li>
              טלפון: <strong><a href="tel:04-6933566">04-6933566</a></strong>
            </li>
            <li>
              דוא״ל: <strong><a href="mailto:eldad@rosman.co.il">eldad@rosman.co.il</a></strong>
            </li>
            <li>רכז/ת נגישות: <strong>אלדד קסלסי</strong></li>
          </ul>
        </div>

        <h2>7. עדכון ההצהרה</h2>
        <p>
          החברה רשאית לעדכן הצהרת נגישות זו מעת לעת, בהתאם לשינויים במערכת ו/או בדרישות הדין והתקן.
        </p>
      </article>
    </main>

    <!-- Footer -->
    <footer class="document-footer">
      <p>© 2024 GoFood. כל הזכויות שמורות.</p>
    </footer>
  </div>
</template>

<style scoped>
.document-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-primary);
}

.document-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--border-color);
  padding: var(--spacing-md) var(--spacing-lg);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 800px;
  margin: 0 auto;
}

.back-link {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  color: var(--text-primary);
  text-decoration: none;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  transition: color var(--transition-fast);
}

.back-link:hover {
  color: #d97706;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  text-decoration: none;
}

.logo-img {
  width: 32px;
  height: 32px;
  border-radius: var(--border-radius-sm);
}

.logo-text {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
}

.document-main {
  flex: 1;
  padding: var(--spacing-lg);
}

.document-content {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-xl);
  line-height: 1.8;
}

.document-content h1 {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
  margin: 0 0 var(--spacing-xl) 0;
  padding-bottom: var(--spacing-md);
  border-bottom: 2px solid #d97706;
}

.document-content h2 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  margin: var(--spacing-xl) 0 var(--spacing-md) 0;
}

.document-content h3 {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  margin: 0 0 var(--spacing-sm) 0;
}

.document-content p {
  margin: 0 0 var(--spacing-sm) 0;
  color: var(--text-secondary);
}

.document-content ul {
  margin: var(--spacing-sm) 0 var(--spacing-md) 0;
  padding-right: var(--spacing-xl);
}

.document-content ul ul {
  margin: var(--spacing-xs) 0;
}

.document-content li {
  margin-bottom: var(--spacing-xs);
  color: var(--text-secondary);
}

.document-content strong {
  color: var(--text-primary);
}

.document-content a {
  color: #d97706;
  text-decoration: none;
}

.document-content a:hover {
  text-decoration: underline;
}

.contact-box {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 1px solid #f59e0b;
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-lg);
  margin: var(--spacing-lg) 0;
}

.contact-box h3 {
  color: #92400e;
}

.contact-box ul {
  margin-bottom: 0;
}

.document-footer {
  text-align: center;
  padding: var(--spacing-lg);
  color: var(--text-muted);
  font-size: var(--font-size-xs);
  border-top: 1px solid var(--border-color);
}

.document-footer p {
  margin: 0;
}

@media (max-width: 768px) {
  .document-content {
    padding: var(--spacing-lg);
  }

  .document-content h1 {
    font-size: var(--font-size-xl);
  }
}
</style>
